export const curlEndpoints = {
    anonymousid:
`/* anon_id */

curl "https://g.tenor.com/v1/anonid?key=LIVDSRZULELA"`,

    trendinggifs:
`/* trending GIFs call */

curl "https://g.tenor.com/v1/trending?key=LIVDSRZULELA"`,

    categories:
`/* categories call */

curl "https://g.tenor.com/v1/categories?key=LIVDSRZULELA"`,

    search:
`/* search for excited top 8 GIFs */

curl "https://g.tenor.com/v1/search?q=excited&key=LIVDSRZULELA&limit=8"`,

    registershare:
`/* register share */

curl "https://g.tenor.com/v1/registershare?id=8776030&q=excited&key=LIVDSRZULELA"`,

    autocomplete:
`/* autocomplete */

curl "https://g.tenor.com/v1/autocomplete?q=exc&key=LIVDSRZULELA"`,

    suggestions:
`/* search suggestion */

curl "https://g.tenor.com/v1/search_suggestions?q=excited&key=LIVDSRZULELA"`,

    gifs:
`/* GIFs endpoint */

curl "https://g.tenor.com/v1/gifs?ids=8776030&key=LIVDSRZULELA"`,

    random:
`/* random endpoint */

curl "https://g.tenor.com/v1/random?q=excited&key=LIVDSRZULELA"`,

    trendingterms:
`/* trending Terms call */

curl "https://g.tenor.com/v1/trending_terms?key=LIVDSRZULELA"`,

    search_stickers:
`/* search for excited top 10 stickers */

curl "https://g.tenor.com/v1/search?searchfilter=sticker&q=excited&key=LIVDSRZULELA&limit=10"`,

    trending_stickers:
`/* trending Stickers call */

curl "https://g.tenor.com/v1/trending?searchfilter=sticker&key=LIVDSRZULELA"`,
};

export const curlQuickStart = {
    launch:
`/* trending GIFs call */
curl "https://g.tenor.com/v1/trending?key=LIVDSRZULELA"

/* categories call */
curl "https://g.tenor.com/v1/categories?key=LIVDSRZULELA"
`,

    search:
`/* search for excited top 8 GIFs */
curl "https://g.tenor.com/v1/search?q=excited&key=LIVDSRZULELA&limit=8"
`,

    registershare:
`/* register share */

curl "https://g.tenor.com/v1/registershare?id=8776030&key=LIVDSRZULELA&q=excited"
`,

    autocomplete:
`/* autocomplete */

curl "https://g.tenor.com/v1/autocomplete?q=exc&key=LIVDSRZULELA"
`,

    suggestions:
`/* search suggestion */

curl "https://g.tenor.com/v1/search_suggestions?q=smile&key=LIVDSRZULELA&limit=5"
`};
